<template>
	<div class="parts-locations-printing-card">
		<!-- Invoice Printing Section -->
		<SectionContainer>
			<template #left>
				<h4>Invoice Printing</h4>
			</template>
			<template #content>
				<ul>
					<li>Parts Invoice</li>
					<li>Print Prompt At Close</li>
					<li>Print SOP</li>
					<li>Salesperson</li>
					<li>States Disclosures</li>
				</ul>
			</template>
		</SectionContainer>
		<!-- Quote Printing Section -->
		<SectionContainer>
			<template #left>
				<h4>Quote Printing</h4>
			</template>
			<template #content>
				<!-- Shared Settings -->
				<ul>
					<li>Salesperson</li>
				</ul>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'PartsLocationsPrintingCard',
	components: { SectionContainer }
};
</script>

<style lang="scss" scoped>
.parts-locations-printing-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
